'use client'
import { Box, Flex, NumberInput, NumberInputProps, Stack, Text } from '@mantine/core'

import { useCoinContext } from '@/app/[locale]/price/[slug]/_contexts/CoinContext'
import ArrowUpDown from '@/assets/icons/arrow-up-down.svg'
import CoinIcon from '@/components/CoinIcon'

import FakeSelector from '../FakeSelector'
import { usePriceConvert } from './hooks'
import styles from './index.module.css'
import MoneyItems from './MoneyItems'

const TO_VALUE_VARIANT = 'body-emphasis'

export default function PriceConvertor({ openCoinListModal }: { openCoinListModal: () => void }) {
  const {
    fromValue,
    toValue,
    fromSymbol,
    toSymbol,
    onInputValue,
    toggleReversed,
    setCurrencyValue,
  } = usePriceConvert()

  const onFocus: NumberInputProps['onFocus'] = ev => {
    // Move cursor to the end of the input when focused
    const input = ev.target
    const valueLength = input.value.length
    ev.target.setSelectionRange(valueLength, valueLength)
    input.scrollLeft = input.scrollWidth
  }

  const { coin } = useCoinContext()

  return (
    <Stack gap={12}>
      <Box className={styles.priceConvertor}>
        <Flex className={styles.fromContainer}>
          <Flex className={styles.inputContainer}>
            <Flex className={styles.fromNumberContainer}>
              <NumberInput
                variant={'unstyled'}
                classNames={{
                  input: styles.fromNumber,
                }}
                value={fromValue}
                hideControls={true}
                onChange={onInputValue}
                onFocus={onFocus}
              />
              <Text style={{ visibility: 'hidden' }} className={styles.fromNumber}>
                {fromSymbol}
              </Text>
              <Flex className={styles.currencyContainer}>
                <Text
                  style={{ visibility: 'hidden', overflow: 'hidden' }}
                  className={styles.fromNumber}
                >
                  {fromValue}
                </Text>
                <Text c={'var(--content-tertiary)'} className={styles.fromNumber}>
                  {fromSymbol}
                </Text>
              </Flex>
            </Flex>
          </Flex>
          <FakeSelector
            bg={'var(--bg-surface-primary)'}
            onClick={openCoinListModal}
            content={
              <Flex>
                <CoinIcon coin={coin} />
                <Text variant={'subtitle'} ml={8}>
                  {coin.symbol}
                </Text>
              </Flex>
            }
          />
        </Flex>
        <Flex mt={10} align={'center'}>
          <Text c={'var(--content-tertiary)'} variant={TO_VALUE_VARIANT}>
            ≈
          </Text>
          <Text mx={4} variant={TO_VALUE_VARIANT}>
            {toValue}
          </Text>
          <Text mr={4} c={'var(--content-tertiary)'} variant={TO_VALUE_VARIANT}>
            {toSymbol}
          </Text>
          <ArrowUpDown onClick={toggleReversed} className={styles.arrowUpDown} />
        </Flex>
      </Box>
      <MoneyItems setCurrencyValue={setCurrencyValue} />
    </Stack>
  )
}
